module.exports = __webpack_public_path__ + "static/media/etiquettes-transport.440f554b.png";